<!-- (value) => props.perPageChanged({ currentPerPage: value })-->
<template>
  <div style="height: 100%">
    <vx-card style="height: 100%">
      <div style="margin-bottom: 15px; height: 100%">
        <b-form-group>
          <div>
            <b-row align-v="center">
              <b-col lg="3" sm="6">
                <b-form-input
                  v-model="searchTerm"
                  placeholder="Arama..."
                  @input="aramaFunc"
                  type="text"
                  class="d-inline-block"
                />
              </b-col>
              <b-col lg="2" sm="6">
                <vs-button
                  style="border-radius: 5px; width: 100%"
                  type="gradient"
                  @click="aramaFunc"
                  id="button-with-loading-yeni"
                  class="vs-con-loading__container"
                  >Listele</vs-button
                >
              </b-col>
              <b-col lg="2" sm="6">
                <vs-button
                  :disabled="selectedDataFor == ''"
                  style="border-radius: 5px; width: 100%"
                  type="gradient"
                  @click="toggleDataSidebar(true)"
                  id="button-with-loading-yeni"
                  class="vs-con-loading__container"
                  >Güncel Mutabakat Gönder</vs-button
                >
              </b-col>
            </b-row>
          </div>
        </b-form-group>
      </div>
      <b-row style="margin-top: 10px">
        <b-col lg="2" sm="6">
          <vs-button
            style="border-radius: 5px; width: 100%"
            type="gradient"
            size="small"
            @click="resetState"
            color="success"
            >{{ title }}</vs-button
          >
        </b-col>
      </b-row>
      <ag-grid-vue
        v-if="!isMobile()"
        style="width: 100%; height: 450px; margin-top: 10px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowSelection="rowSelection"
        :rowData="rowData"
        :localeText="localeText"
        @grid-ready="onGridReady"
        @rowClicked="onSelectionChanged"
        @first-data-rendered="onFirstDataRendered"
        @filter-changed="onFilterChanged"
        @filter-modified="onFilterModified"
        :suppressRowClickSelection="true"
        @selection-changed="onSelectionChangedRow"
      >
      </ag-grid-vue>
      <ag-grid-vue
        v-else
        style="width: 100%; height: 450px; margin-top: 10px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefsMobil"
        :rowSelection="rowSelection"
        :rowData="rowData"
        :localeText="localeText"
        @grid-ready="onGridReady"
        @rowClicked="onSelectionChanged"
        @filter-changed="onFilterChanged"
        @filter-modified="onFilterModified"
        @selection-changed="onSelectionChangedRow"
      >
      </ag-grid-vue>
      <div class="d-flex justify-content-between flex-wrap">
        <div class="d-flex align-items-center mb-0 mt-1">
          <span class="text-nowrap"
            >{{ toplamKayitSayisi }} kayıt arasından gösterilen kayıt
          </span>
          <b-form-select
            v-model="pageLength"
            :options="['50', '100', '250', '500', '1000']"
            class="mx-1"
            v-on:change="aramaFunc()"
          />
        </div>
        <div>
          <b-pagination
            value="1"
            :total-rows="KAYITSAYISI"
            :per-page="pageLength"
            first-number
            last-number
            align="right"
            prev-class="prev-item"
            next-class="next-item"
            class="mt-1 mb-0"
            v-model="currentGelenPage"
            @input="aramaFunc()"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </div>
    </vx-card>
    <CariEkstreComponent ref="cariekstreref" />
    <GuncelMutabakatPopup
      :isSidebarActive="isSidebarActiveGm"
      :data="selectedDataFor"
      @closeSidebar="toggleDataSidebar"
    />
    <!-- input search -->
  </div>
</template>

<script>
import CariEkstreComponent from "../components/crm-components/finans-components/CariEkstreComponent.vue";
import ButtonPrimary from "../components/crm-components/global-components/ButtonPrimary.vue";
import { isMobile } from "mobile-device-detect";
import {
  BPagination,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import Store from "../../store/store";
import state from "../../store/state";
import router from "../../router";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import CariKartlarDetayButon from "../components/crm-components/finans-components/CariKartlarDetayButon.vue";
import GuncelMutabakatPopup from "./CellRenderers/GuncelMutabakatPopup.vue";

export default {
  components: {
    GuncelMutabakatPopup,
    ButtonPrimary,
    CariKartlarDetayButon,
    BPagination,
    AgGridVue,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    CariEkstreComponent,
  },
  data() {
    return {
      isSidebarActiveGm: false,

      selectedDataFor: "",

      toplamKayitSayisi: 0,
      rowSelection: null,
      size: "small",
      title: "Filtrelemeyi Resetle",
      filtrecolor: "success",
      rowData: null,
      localeText: null,

      columnDefs: null,

      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      pageLength: 50,
      KAYITSAYISI: 0,
      currentGelenPage: 0,
      dir: false,

      rows: [],
      searchTerm: "",
      gelenfiltre: "",
    };
  },
  methods: {
    toggleDataSidebar(val = false) {
      try {
        this.isSidebarActiveGm = val;
      } catch (error) {
        console.log(error);
      }
    },
    isMobile: function () {
      /*	var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;*/
      return isMobile;
    },
    currencyFormatter(currency, sign) {
      if (currency == "") {
        return "";
      } else {
        var sansDec = currency.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + `${formatted}`;
      }
    },
    resetState() {
      this.gridApi.setFilterModel(null);
      this.gelenfiltre = "";
      this.listACT();
    },
    onFilterChanged(e) {
      var savedFilterModel = e.api.getFilterModel();
      var keys = Object.keys(savedFilterModel);

      if (keys.length > 1) {
        console.log("arama yapma");
      } else {
        var vm = this;
        const soap = require("soap");
        const url = state.sistemAddress;
        if (vm.gelenfiltre == "") {
          vm.listACT();
        } else {
          const args = {
            token: Store.state.tokenId,
            ARANAN: vm.gelenfiltre,
            ILKKAYIT: "1",
            SONKAYIT: "1000000",
          };
          soap.createClient(url, function (err, client) {
            client.INT_ACTLIST(args, function (err, result) {
              if (result.INT_ACTLISTResult == "0") {
                Store.dispatch("logout");
                //this.$store.dispatch('login', payload)
              }

              try {
                vm.veriler = JSON.parse(result.INT_ACTLISTResult);
                if (vm.veriler.response == "Ok") {
                  vm.KAYITSAYISI = "1";
                  vm.rowData = JSON.parse(vm.veriler.jsonData);
                  vm.toplamKayitSayisi = vm.rowData[0].KAYITSAYISI;
                } else {
                }
              } catch (error) {}
            });
          });
        }
      }
    },
    onFilterModified(e) {
      if (e.filterInstance.getModelFromUi() == null) console.log("in");
      else this.gelenfiltre = e.filterInstance.getModelFromUi().filter;
    },
    onSelectionChanged(params) {
      this.$store.commit("account/TAHSILAT_DETAY", params.node.data);
    },
    onSelectionChangedRow(params) {
      let selectedDataForLc = this.gridApi.getSelectedRows();
      this.selectedDataFor = selectedDataForLc[0]; 
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    aramaFunc() {
      var vm = this;
      var vs = this.$vs;
      vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-yeni",
        scale: 0.45,
      });
      const soap = require("soap");
      const url = state.sistemAddress;
      if (this.searchTerm == "") {
        this.listACTgetKayit();
        this.listACT();
      } else {
        const args = {
          token: Store.state.tokenId,
          ARANAN: this.searchTerm,
          ILKKAYIT: "1",
          SONKAYIT: "100000000",
        };
        soap.createClient(url, function (err, client) {
          client.INT_ACTLIST(args, function (err, result) {
            if (result.INT_ACTLISTResult == "0") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_ACTLISTResult);

              if (vm.veriler.response == "Ok") {
                var list = JSON.parse(vm.veriler.jsonData);
                vm.KAYITSAYISI = "1";
                vm.rowData = list;
                vm.toplamKayitSayisi = vm.rowData[0].KAYITSAYISI;

                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              } else {
                vs.notify({
                  title: "Uyarı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center",
                });
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              }
            } catch (error) {
              vs.notify({
                title: "Hata",
                text: "Liste getirilirken hata oluştu.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            }
          });
        });
      }
    },
    pageLoad() {},
    cariEkstre(ACTID, ACTNAME) {
      //  alert(ACTID);
      this.$refs.cariekstreref.cariEkstre(ACTID, ACTNAME);
    },
    tahsilat(ACTID, ACTNAME) {
      this.$store.commit("account/ITEM_ACTID", ACTID);
      //  this.$store.state.account.ACTID = ACTID;
      this.$store.commit("account/ITEM_ACTNAME", ACTNAME);

      //    this.$store.state.account.ACTNAME = ACTNAME;

      //  alert(ACTID);
      //  this.$refs.tahsilatref.tahsilatCek(ACTID, ACTNAME);

      router.push({
        name: "CariTahsilat",
        params: { act_id: ACTID, act_name: ACTNAME },
      });
    },
    listACT(pageLength) {
      var sonkayitcurrentGelenPage = this.currentGelenPage - 1;

      var vm = this;
      var vs = this.$vs;
      vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-yeni",
        scale: 0.45,
      });
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ARANAN: "",
        ILKKAYIT: this.pageLength * sonkayitcurrentGelenPage,
        SONKAYIT: this.pageLength,
      };
      soap.createClient(url, function (err, client) {
        client.INT_ACTLIST(args, function (err, result) {
          if (result.INT_ACTLISTResult == "0") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_ACTLISTResult);
            if (vm.veriler.response == "Ok") {
              vm.rowData = JSON.parse(vm.veriler.jsonData);
              vm.KAYITSAYISI = vm.rowData[0].KAYITSAYISI;
              vm.toplamKayitSayisi = vm.rowData[0].KAYITSAYISI;

              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            } else {
              vs.notify({
                title: "Uyarı",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center",
              });
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            }
          } catch (error) {
            vs.notify({
              title: "Hata",
              text: "Liste getirilirken hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
          }
        });
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },

    listACTgetKayit() {
      var vm = this;
      var vs = this.$vs;
      vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-yeni",
        scale: 0.45,
      });
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ARANAN: "",
        ILKKAYIT: "1",
        SONKAYIT: "1",
      };
      soap.createClient(url, function (err, client) {
        client.INT_ACTLIST(args, function (err, result) {
          if (result.INT_ACTLISTResult == "0") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_ACTLISTResult);
            if (vm.veriler.response == "Ok") {
              var list = JSON.parse(vm.veriler.jsonData);
              vm.KAYITSAYISI = list[0].KAYITSAYISI;
              vm.toplamKayitSayisi = list[0].KAYITSAYISI;

              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            } else {
              vs.notify({
                title: "Uyarı",
                text: vm.veriler.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "warning",
                position: "top-center",
              });
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            }
          } catch (error) {
            vs.notify({
              title: "Hata",
              text: "Liste getirilirken hata oluştu.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
            vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
          }
        });
      });
    },
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  beforeMount() {
    this.columnDefsMobil = [
      {
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        width: 200,
        field: "",
        cellRendererFramework: "CariKartlarDetayButon",
      },
      {
        headerName: "Firma/Müşteri",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "E-Mail",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "EMAIL",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Telefon",
        field: "PHONE1",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Şehir",
        field: "CITY",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Borç",
        field: "DEBIT",
        sortable: true,
        filter: "agNumberColumnFilter",
        type: "rightAligned",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: (params) => this.currencyFormatter(params.data.DEBIT, "₺"),
      },
      {
        headerName: "Alacak",
        field: "CREDIT",
        valueFormatter: this.parseDate,
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: (params) => this.currencyFormatter(params.data.CREDIT, "₺"),
      },
      {
        headerName: "Bakiye",
        field: "REMTOTAL",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: (params) => this.currencyFormatter(params.data.REMTOTAL, "₺"),
      },
      {
        headerName: "Bakiye Adı",
        field: "REMTYPENAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
    ];
    this.columnDefs = [
      {
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        width: 180,
        field: "",
        cellRendererFramework: "CariKartlarDetayButon",
      },
      {
        headerName: "Firma/Müşteri",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "E-Mail",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "EMAIL",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Telefon",
        field: "PHONE1",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Şehir",
        field: "CITY",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Borç",
        field: "DEBIT",
        sortable: true,
        filter: "agNumberColumnFilter",
        type: "rightAligned",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: (params) => this.currencyFormatter(params.data.DEBIT, "₺"),
      },
      {
        headerName: "Alacak",
        field: "CREDIT",
        valueFormatter: this.parseDate,
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: (params) => this.currencyFormatter(params.data.CREDIT, "₺"),
      },
      {
        headerName: "Bakiye",
        field: "REMTOTAL",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        type: "rightAligned",
        valueFormatter: (params) => this.currencyFormatter(params.data.REMTOTAL, "₺"),
      },
      {
        headerName: "Bakiye Adı",
        field: "REMTYPENAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
    ];
  },

  created() {
    this.listACTgetKayit();
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.rowSelection = "single";
  },
};
</script>
<style lang="scss">
table.vgt-table {
  font-size: small;
}
</style>
